import { render, staticRenderFns } from "./OxygenButtonInput.vue?vue&type=template&id=2274239b&"
import script from "./OxygenButtonInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenButtonInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenButtonInput.vue?vue&type=style&index=0&id=2274239b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports